import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { fadeInUp } from '../../lib/animations';

const SEORelatedLinks = ({ links }) => {
  if (!links || links.length === 0) return null;

  return (
    <motion.section {...fadeInUp} className="mt-20 pt-12 border-t border-white/5">
      <p className="text-sm uppercase tracking-[0.2em] text-[#3b82f6] font-bold mb-6" data-testid="related-links-title">
        Lire aussi
      </p>
      <div className="space-y-3">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="flex items-center justify-between group p-4 rounded-xl border border-white/5 hover:border-[#3b82f6]/30 bg-[#1a1a2e]/30 hover:bg-[#1a1a2e]/60 transition-all"
            data-testid={`related-link-${link.to.slice(1)}`}
          >
            <span className="text-[#f5f5f5] text-sm font-medium group-hover:text-[#3b82f6] transition-colors">
              {link.label}
            </span>
            <ArrowRight className="w-4 h-4 text-[#71717a] group-hover:text-[#3b82f6] group-hover:translate-x-1 transition-all" />
          </Link>
        ))}
      </div>
    </motion.section>
  );
};

export default SEORelatedLinks;
